import React from 'react';

/**
 * Environment icon: cloud (services) connected to a monitor (client).
 * Outline style to match MUI sidebar icons (Dashboard, Folder, etc.).
 * Use currentColor so it inherits text.secondary / primary.main.
 */
const EnvironmentIcon: React.FC<{ fontSize?: 'small' | 'medium' | 'large' | 'inherit'; color?: 'action' | 'inherit'; style?: React.CSSProperties }> = ({
  fontSize = 'inherit',
  color = 'inherit',
  style,
}) => {
  const size = fontSize === 'small' ? 20 : fontSize === 'large' ? 28 : 24;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'inherit', ...style }}
    >
      {/* Cloud (outline) */}
      <path
        d="M12 4c-2.2 0-4 1.6-4.4 3.6C6.4 8 5 9.8 5 12c0 2.2 1.8 4 4 4h10c1.7 0 3-1.3 3-3s-1.3-3-3-3h-.5C17.5 6.5 15 4 12 4z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Three blocks in cloud */}
      <rect x="7" y="8" width="1.8" height="1.2" rx="0.2" fill="currentColor" />
      <rect x="11.1" y="8" width="1.8" height="1.2" rx="0.2" fill="currentColor" />
      <rect x="15.2" y="8" width="1.8" height="1.2" rx="0.2" fill="currentColor" />
      {/* Connection lines down to monitor */}
      <path d="M7.9 9.2L10 12 12 9.2M12 9.2L14 12l2.1-2.8" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Monitor (outline) */}
      <rect x="3" y="14" width="18" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none" />
      {/* Screen content */}
      <rect x="8" y="16" width="8" height="5" rx="0.4" fill="currentColor" />
    </svg>
  );
};

export default EnvironmentIcon;
